import {utilModule} from '../module.js';

utilModule.directive('nsSetFocus', ['$parse','$timeout', function ($parse, $timeout) {
    return {
        restrict: "A",
        link: function (scope, element, attr) {
            // $watch the trigger variable to be set to true to know that the field is visible
            scope.$watch(attr.nsSetFocus, function (newValue) {
                if (newValue == true) {
                    $timeout(function () { // a timing workaround hack
                        element[0].focus(); // without jQuery, need [0]
                    }, 50);
                }
            });

        }
    };
}]);
